"use strict";

import angular from "angular";

import template from "./sidenav-accountings.component.html";
import "./themes/sidenav-accountings.component.scss";
import "./themes/sidenav-accountings.component-dark.scss";

import { User } from "../../../gateway/User/User";
import { HubSpot } from "../../../presentation/services/HubSpot/HubSpot";
import toastCustomTemplate from "../nu-toast-custom/toast-custom.component.html";
import chartScoreAccountingsDialogTemplate from "../../../views/accountings/dialogs/chart-score-accountings/chart-score-accountings-dialog.html";

export class SideNavAccountingsComponent {
    constructor($scope, $mdSidenav, toast, LoaderService, DesnuDialogService) {
        this.$scope = $scope;
        this.$mdSideNav = $mdSidenav;
        this.toast = toast;
        this.LoaderService = LoaderService;
        this.DesnuDialogService = DesnuDialogService;

        this.User = new User();
        this.HubSpot = new HubSpot();
    }

    $onInit() {}

    onShowHistoricScore() {
        this.DesnuDialogService.custom({
            controller: "ChartScoreAccountingsCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                accountingData: this.data.props,
                width: "600px",
                templateHtml: chartScoreAccountingsDialogTemplate,
                title: "Score"
            },
            after: {}
        });
    }

    onClose() {
        this.$mdSideNav(this.componentId).toggle();
    }

    _showToastUpdate(message) {
        this.toast.show("", "bottom right", {
            hideDelay: 1000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: message,
                action: [
                    {
                        style:
                            "md-icon-button dsn-icon-button dsn-icon-button-medium",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    async onInsertHubspot(customer, targetEvent) {
        this.DesnuDialogService.confirmation({
            targetEvent,
            locals: {
                title: "Tem certeza que deseja reenviar?",

                actions: {
                    confirm: {
                        label: "Reenviar",
                        action: async () => {
                            this.DesnuDialogService.hide();
                            this.loading = true;
                            try {
                                await this.HubSpot.insert(customer._id);

                                this.$scope.$applyAsync();

                                this._showToastUpdate(
                                    "Contabilidade cadastrada com sucesso"
                                );
                            } catch (err) {
                                this._showToastUpdate(
                                    "Não foi possivel cadastrar esta contabilidade"
                                );
                            }
                            this.loading = false;
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            this.DesnuDialogService.cancel();
                        }
                    }
                }
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }
}

SideNavAccountingsComponent.$inject = [
    "$scope",
    "$mdSidenav",
    "toast",
    "LoaderService",
    "DesnuDialogService"
];

const name = "sideNavAccountingsComponent";
const def = {
    bindings: {
        data: "<",
        componentId: "@",
        showResend: "=",
        showSeller: "=",
        showCs: "=",
        showRelationship: "=",
        showHubspot: "=",
        showCnpj: "=",
        showPersona: "=",
        showUpdateAccounting: "=",
        showFinancial: "=",
        showOrigin: "="
    },
    controller: SideNavAccountingsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
